import React from 'react';
import { Zap, ChevronRight } from 'lucide-react';
import { useLots } from '../../../contexts/LotsContext';
import { useNavigate } from 'react-router-dom';

const LightningLotsAlert = () => {
  const { lightningLotsCount } = useLots();
  const navigate = useNavigate();

  if (lightningLotsCount === 0) return null;

  console.log('LightningLotsAlert - Rendering with count:', lightningLotsCount);

  return (
    <div 
      onClick={() => {
        navigate('/', { 
          replace: true,
          state: { 
            activeScreen: 'inventory',
            filter: 'lightning'
          }
        });
      }}
      className="w-full bg-amber-50 hover:bg-amber-100 p-4 rounded-lg shadow-sm flex items-center justify-between cursor-pointer"
    >
      <div className="flex items-center gap-3">
        <div className="bg-amber-100 p-2 rounded-full">
          <Zap className="w-5 h-5 text-amber-600" />
        </div>
        <div className="font-medium text-amber-900">
          {lightningLotsCount} {lightningLotsCount === 1 ? 'lote' : 'lotes'} relámpago
        </div>
      </div>
      <ChevronRight className="w-5 h-5 text-amber-600" />
    </div>
  );
};

export default LightningLotsAlert; 